import { render, staticRenderFns } from "./paymentForm.vue?vue&type=template&id=2bb82e55&scoped=true&"
import script from "./paymentForm.vue?vue&type=script&lang=js&"
export * from "./paymentForm.vue?vue&type=script&lang=js&"
import style0 from "./paymentForm.vue?vue&type=style&index=0&id=2bb82e55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb82e55",
  null
  
)

export default component.exports